export const types = {
    ASSIGN: 'ASSIGN',
    ADD:'ADD',
    DELETE:'REMOVE'
};